"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/Composer.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _broadcastCampaign = require('shared/validation/broadcastCampaign');
var _secureText = require('shared/constants/secureText');
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _broadcastTemplate = require('shared/services/broadcastTemplate');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _InsertVariableMenu = require('./InsertVariableMenu'); var _InsertVariableMenu2 = _interopRequireDefault(_InsertVariableMenu);
var _VariablePopover = require('./VariablePopover'); var _VariablePopover2 = _interopRequireDefault(_VariablePopover);
var _format = require('web/screens/Broadcast/format');























/* A token needs attention when it can't resolve for someone: it names no
 * declared variable, or some recipients lack its value and it has no fallback. */
const isTokenAtRisk = (token, coverage, gate) => {
  if (!token.isValidName) return true
  if (token.fallback !== null) return false
  // A built-in (Rev 24 M1) isn't in the coverage probe; the gate reports it
  // (Rev 35 E4).
  if (_broadcastTemplate.isBuiltInVariable.call(void 0, token.name)) return !!_optionalChain([gate, 'optionalAccess', _ => _.MissingVariables, 'access', _2 => _2.some, 'call', _3 => _3(v => v.Name === token.name && v.Count > 0)])
  if (!coverage) return false
  const c = coverage.find(v => v.Name === token.name)
  if (!c) return true
  return c.have < c.total
}

/* Rev 35 E4: a token with a fallback reads as a chip, "first_name · if
 * blank: there", unless the caret is inside it. The token's own text stays
 * underneath, invisible, so the backdrop lines up with the textarea. A caret
 * at either edge is outside: inserting a variable leaves the caret right after
 * it, and the chip must not flip to raw text and back as typing goes on. The
 * template editor (web/components/MessageTemplates) draws its variables with
 * it too. */
 const highlight = (
  template,
  coverage,
  gate,
  caretAt,
) => {
  const parts = []
  let last = 0
  _broadcastTemplateTokens.templateTokens.call(void 0, template).forEach((token, i) => {
    parts.push(template.slice(last, token.index))
    const isChip = token.isValidName && token.fallback !== null
      && (caretAt === null || caretAt <= token.index || caretAt >= token.index + token.text.length)
    parts.push(
      _react2.default.createElement('span', {
        key: i,
        'data-token-index': token.index,
        className: _classBuilder2.default.call(void 0, 
          'broadcast-composer--token',
          isTokenAtRisk(token, coverage, gate) && 'broadcast-composer--token--warn',
          token.isValidName && token.fallback !== null && 'broadcast-composer--token--default',
          isChip && 'broadcast-composer--chip',
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}

        ,  isChip
          ? (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('span', { className: "broadcast-composer--chip-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}},  token.text )
                , _react2.default.createElement('span', { className: "broadcast-composer--chip-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}},  `${token.name} · if blank: ${token.fallback}` )
              )
            )
          : token.text 
      ),
    )
    last = token.index + token.text.length
  })
  parts.push(template.slice(last))
  // A trailing newline keeps the backdrop as tall as the textarea's last line.
  parts.push('\n')
  return parts
}; exports.highlight = highlight

const Composer = ({
  template,
  onChangeTemplate,
  fields,
  coverage,
  messageType,
  limit,
  gate,
  focusVariable = null,
  isFocusedOnOpen = false,
  caret,
  footnote = null,
}) => {
  const editorRef = _react.useRef(null)
  const containerRef = _react.useRef(null)
  // Where the caret is while the editor has focus; a token it's in shows its text.
  const [caretAt, setCaretAt] = _react.useState(null)
  const highlighted = _react.useMemo.call(void 0, () => exports.highlight.call(void 0, template, coverage, gate, caretAt), [template, coverage, gate, caretAt])
  const tokens = _react.useMemo.call(void 0, () => _broadcastTemplateTokens.templateTokens.call(void 0, template), [template])

  // F3: the token whose default is being edited, and where to show the popover.
  const [popover, setPopover] = _react.useState(null)
  const closePopover = _react.useCallback.call(void 0, () => setPopover(null), [])

  const openPopover = _react.useCallback.call(void 0, 
    (token) => {
      const container = containerRef.current
      const span = _optionalChain([container, 'optionalAccess', _4 => _4.querySelector, 'call', _5 => _5(`[data-token-index="${token.index}"]`)])
      if (!container || !span) return
      const box = container.getBoundingClientRect()
      const rect = span.getBoundingClientRect()
      const width = Math.min(340, box.width)
      setPopover({
        token,
        top: rect.bottom - box.top + 6,
        left: Math.max(0, Math.min(rect.left - box.left, box.width - width)),
      })
    },
    [],
  )

  const onEditorClick = () => {
    const editor = editorRef.current
    if (!editor || editor.selectionStart !== editor.selectionEnd) return
    const token = _broadcastTemplateTokens.tokenAt.call(void 0, tokens, editor.selectionStart)
    if (_optionalChain([token, 'optionalAccess', _6 => _6.isValidName])) openPopover(token)
  }

  // Once, on mount: the caret goes after the text.
  const initialFocus = _react.useRef.call(void 0, { isFocusedOnOpen, hasVariable: !!focusVariable, at: _nullishCoalesce(_optionalChain([caret, 'optionalAccess', _7 => _7.current]), () => ( null)) })
  _react.useEffect.call(void 0, 
    () => {
      const { isFocusedOnOpen: should, hasVariable, at: wasAt } = initialFocus.current
      const editor = editorRef.current
      if (!should || hasVariable || !editor) return
      editor.focus()
      const at = Math.min(_nullishCoalesce(wasAt, () => ( editor.value.length)), editor.value.length)
      editor.setSelectionRange(at, at)
    },
    [],
  )

  const focusedOnce = _react.useRef.call(void 0, false)
  _react.useEffect.call(void 0, 
    () => {
      if (!focusVariable || focusedOnce.current) return
      const token = tokens.find(t => t.name === focusVariable)
      if (!token) return
      focusedOnce.current = true
      openPopover(token)
    },
    [focusVariable, tokens, openPopover],
  )

  const applyDefault = (value, applyToAll) => {
    if (!popover) return
    const next = _broadcastTemplateTokens.setTokenDefault.call(void 0, template, popover.token, value, applyToAll)
    if (next.length > limit) return
    onChangeTemplate(next)
    setPopover(null)
    requestAnimationFrame(() => _optionalChain([editorRef, 'access', _8 => _8.current, 'optionalAccess', _9 => _9.focus, 'call', _10 => _10()]))
  }

  const insertVariable = (name, fallback) => {
    const editor = editorRef.current
    // Rev 31 v2: a variable's default lives on the variable, not in the token.
    // Rev 35 E4: a name's fallback is in the token.
    const token = fallback ? `{{${name} | ${fallback}}}` : `{{${name}}}`
    const start = _nullishCoalesce(_optionalChain([editor, 'optionalAccess', _11 => _11.selectionStart]), () => ( template.length))
    const end = _nullishCoalesce(_optionalChain([editor, 'optionalAccess', _12 => _12.selectionEnd]), () => ( start))
    const next = template.slice(0, start) + token + template.slice(end)
    if (next.length > limit) return
    onChangeTemplate(next)
    requestAnimationFrame(() => {
      _optionalChain([editor, 'optionalAccess', _13 => _13.focus, 'call', _14 => _14()])
      _optionalChain([editor, 'optionalAccess', _15 => _15.setSelectionRange, 'call', _16 => _16(start + token.length, start + token.length)])
    })
  }

  const isSecure = messageType !== _broadcastCampaign.MessageType.InsecureSMS
  const longest = _optionalChain([gate, 'optionalAccess', _17 => _17.Longest, 'optionalAccess', _18 => _18.Length])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "broadcast-composer--varbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}
        , _react2.default.createElement(_InsertVariableMenu2.default, { fields: fields, onInsert: insertVariable, __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}} )
      )
      , _react2.default.createElement('div', { className: "broadcast-composer--editor", ref: containerRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
        , _react2.default.createElement('div', { className: "broadcast-composer--editor-backdrop", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}},  highlighted )
        , _react2.default.createElement('textarea', {
          ref: editorRef,
          'aria-label': "Message",
          className: "broadcast-composer--editor-input",
          value: template,
          maxLength: limit,
          spellCheck: false,
          placeholder: "Type your message..."  ,
          onChange: e => onChangeTemplate(e.target.value),
          onClick: onEditorClick,
          onSelect: e => {
            const { selectionStart, selectionEnd } = e.currentTarget
            if (caret) caret.current = selectionStart
            setCaretAt(selectionStart === selectionEnd ? selectionStart : null)
          },
          onBlur: () => setCaretAt(null), __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}
        )
        ,  popover && (
          _react2.default.createElement(_VariablePopover2.default, {
            key: popover.token.index,
            token: popover.token,
            template: template,
            uses: tokens.filter(t => t.name === popover.token.name).length,
            coverage: _nullishCoalesce(_optionalChain([coverage, 'optionalAccess', _19 => _19.find, 'call', _20 => _20(c => c.Name === popover.token.name)]), () => ( null)),
            position: { top: popover.top, left: popover.left },
            onApply: applyDefault,
            exceedsLimit: (value, all) => _broadcastTemplateTokens.setTokenDefault.call(void 0, template, popover.token, value, all).length > limit,
            limit: limit,
            onClose: closePopover, __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}
          )
        )
      )
      , _react2.default.createElement('div', { className: "broadcast-composer--under", __self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}
        ,  footnote 
        , _react2.default.createElement('div', { className: "broadcast-composer--counter", __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}
          ,  _format.formatCount.call(void 0, _broadcastTemplate.renderLength.call(void 0, template)) , " characters in the template"
          ,  longest !== undefined && (
            _react2.default.createElement(_react2.default.Fragment, null, " · longest render "    ,  _format.formatCount.call(void 0, longest) , " of "  ,  _format.formatCount.call(void 0, limit) , " characters" )
          )
          ,  ` (${isSecure ? _secureText.SECURE_TEXT_LABEL : _secureText.INSECURE_TEXT_LABEL})` 
        )
      )
    )
  )
}

exports. default = Composer
